import api from "../../api.js";

export const listCompanyApplications = async () => {
  try {
    const res = await api.get("/api/admin/company-applications");
    return res.data;
  } catch (err) {
    console.error("Error in listCompanyApplications:", err);
    throw err;
  }
};

export const approveCompanyApplication = async (cipcregistrationnumber) => {
  try {
    const res = await api.post("/api/admin/company-applications/approve", {
      cipcregistrationnumber,
    });
    return res.data;
  } catch (err) {
    console.error("Error in approveCompanyApplication:", err);
    throw err;
  }
};

export const rejectCompanyApplication = async (cipcregistrationnumber) => {
  try {
    const res = await api.post("/api/admin/company-applications/reject", {
      cipcregistrationnumber,
    });
    return res.data;
  } catch (err) {
    console.error("Error in rejectCompanyApplication:", err);
    throw err;
  }
};
